$(document).ready(function () {
  function capitalize(string) {
    if (!string) return string; // Handle empty strings
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  console.log('admin loaded');
  //upload image
  $("#editAdminProfile").on("change", ".upload-profile-image", function () {
    console.log('image upload trigger 3434');
    readURL(this, $("#editAdminProfile").find(".admin-profile-image .profile-image"));
  });

  function readURL(input, container) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        container.attr('src', e.target.result);
        $("#createCategory").find(".image-container").removeClass("hide");
        $("#createCategory").find(".image-button").addClass("hide");
      }
      reader.readAsDataURL(input.files[0]);
    }
  }
  //search for admin
  $(document).on("change", '.search-admin', function (e) {

    // var exists = body.find("tr[name='" + result.data.date_range + "']")
    // console.log('exists? ', exists.length, exists)
    // if (exists.length) {
    //   alert('Date range already exists');
    // }
    // else {
    //   alert('Report generated successfully.')
    //   var summaryRow = $("<tr name='" + result.data.date_range + "'></tr>");
    //   summaryRow.append("<td>" + result.data.date_range + "</td>");
    //   summaryRow.append("<td> " + result.data.total_items + "</td>");
    //   summaryRow.append("<td>" + result.data.orders_received + "</td>");
    //   summaryRow.append("<td> " + result.data.pending_orders + "</td>");
    //   summaryRow.append("<td> " + result.data.completed_orders + "</td>");
    //   summaryRow.append("<td> " + result.data.total_revenue + "</td>");
    //   summaryRow.append("<td> <button class='btn btn-info btn-export' startdate='" + result.data.start_date + "' enddate='" + result.data.end_date + "'>Export</button >  </td>")
    //   body.append(summaryRow);
    //   console.log('summaryRow', summaryRow)
    console.log('event data:', e)
    console.log('this data', $(this).val());
    var tablebody = $(document).find('table').find('tbody').first()
    if ($(this).val().length > 0) {
      var user_id = $(this).attr('data-userid')
      console.log('user id: ', user_id)
      var encodedSearchVal = encodeURIComponent($(this).val());
      $.ajax({
        type: "GET",
        url: "/admins?search=" + encodedSearchVal,
        success: function (result) {
          console.log('success', result)
          tablebody.empty();

          result.data.forEach(function (staff) {
            var status = staff.status === "active" ? "success" : "danger"
            var staffRow = $("<tr id='" + staff.id + "' name='" + staff.first_name + staff.last_name + "' class='gradeX admin-row'></tr>");
            staffRow.append("<td>" + staff.id + "</td>")
            staffRow.append("<td><img src='" + staff.profile_image + "' class='admin-admins admin-row img' /></td>")
            staffRow.append("<td>" + staff.last_name + "</td>")
            staffRow.append("<td>" + staff.first_name + "</td>")
            staffRow.append("<td>" + staff.email + "</td>")
            staffRow.append("<td ><div class='badge badge-" + status + "'>" + capitalize(staff.status) + "</div></td>")
            console.log('condition values:', user_id, staff.id, user_id === staff.id);
            console.log('Type of user_id:', typeof user_id);
            console.log('Type of staff.id:', typeof staff.id);

            user_id = parseInt(user_id);
            // Convert staff.id to integer
            staff.id = parseInt(staff.id);
            console.log('condition values after converting:', user_id, staff.id, user_id === staff.id);
            if (user_id === staff.id) {
              staffRow.append("<td><div class='inline-block row'><a href='../admins/" + staff.id + "'><button class='btn btn-outline-info mr-1'><i class='fa fa-eye'></i></button></a></div></td>")
            }
            else {
              staffRow.append("<td><div class='inline-block row'><a href='../admins/" + staff.id + "'><button class='btn btn-outline-info mr-1'><i class='fa fa-eye'></i></button></a><form class='button_to' method='post' action='../staffs/" + staff.id + "'></form></div></td>")
            }
            tablebody.append(staffRow);
          });
        },
        error: function (xhr, status, error) {
          console.log('error')
        }
      })
    }
    else {
      var user_id = $(this).attr('data-userid')
      console.log('user id: ', user_id)
      $.ajax({
        type: "GET",
        url: "/admins?search=all",
        success: function (result) {
          // Handle success, such as updating the DOM with the new staff data

          console.log('success', result)
          tablebody.empty();
          result.data.forEach(function (staff) {
            var status = staff.status === "active" ? "success" : "danger"
            var staffRow = $("<tr id='" + staff.id + "' name='" + staff.first_name + staff.last_name + "' class='gradeX admin-row'></tr>");
            staffRow.append("<td>" + staff.id + "</td>")
            staffRow.append("<td><img src='" + staff.profile_image + "' class='admin-admins admin-row img' /></td>")
            staffRow.append("<td>" + staff.last_name + "</td>")
            staffRow.append("<td>" + staff.first_name + "</td>")
            staffRow.append("<td>" + staff.email + "</td>")
            staffRow.append("<td ><div class='badge badge-" + status + "'>" + capitalize(staff.status) + "</div></td>")
            console.log('condition values:', user_id, staff.id, user_id === staff.id);
            console.log('Type of user_id:', typeof user_id);
            console.log('Type of staff.id:', typeof staff.id);

            user_id = parseInt(user_id);
            // Convert staff.id to integer
            staff.id = parseInt(staff.id);
            console.log('condition values after converting:', user_id, staff.id, user_id === staff.id);
            if (user_id === staff.id) {
              staffRow.append("<td><div class='inline-block row'><a href='../admins/" + staff.id + "'><button class='btn btn-outline-info mr-1'><i class='fa fa-eye'></i></button></a></div></td>")
            }
            else {
              staffRow.append("<td><div class='inline-block row'><a href='../admins/" + staff.id + "'><button class='btn btn-outline-info mr-1'><i class='fa fa-eye'></i></button></a><form class='button_to' method='post' action='../admins/" + staff.id + "'></form></div></td>")
            }
            tablebody.append(staffRow);
          });
        },
        error: function (xhr, status, error) {
          console.log('error')
        }
      })
    }
  })
  $("#editAdminProfile").on("click", ".btn-update", function () {
    // Capture input values
    var firstName = $("input[name='user[first_name]']").val();
    var lastName = $("input[name='user[last_name]']").val();
    var phoneNumber = $("input[name='user[phone_number]']").val();
    var address1 = $("input[name='user[address_1]']").val();
    var address2 = $("input[name='user[address_2]']").val();
    var adminId = $(this).val();
    // Prepare form data including the profile image
    var formData = new FormData();
    var profileImage = $("input[name='user[profile_image]']")[0].files[0];
    console.log(adminId, "initiating update", firstName, lastName, phoneNumber, address1, address2);
    formData.append("user[first_name]", firstName);
    formData.append("user[last_name]", lastName);
    formData.append("user[phone_number]", phoneNumber);
    formData.append("user[address_1]", address1);
    formData.append("user[address_2]", address2);
    if (profileImage !== undefined) {
      console.log('appending profile image')
      formData.append("user[profile_image]", profileImage);
    }


    // Send AJAX request
    $.ajax({
      type: "PATCH", // Assuming you're updating the profile via PATCH request
      url: "/admins/" + adminId + "/update_profile", // Update the URL as per your routes
      data: formData,
      contentType: false,
      processData: false,
      success: function (response) {
        $(".message-row .message").removeClass("hide").html("Profile updated successfully");
        $(".message-row .error").addClass("hide")
      },
      error: function (xhr, status, error) {
        // Handle error response
        console.error("Error updating profile:", error);
        // You can show an error message to the user
      }
    });
  });

  $(document).on("click", ".btn-invite", function () {
    var $popup = $("#inviteAdmin");
    $popup.find(".email, .first-name, .last-name").val("");
    $popup.find(".email").get(0).focus();
    $popup.find(".loading-div.whirl.no-overlay").addClass("hide");
    $popup.find(".buttons-row").removeClass("hide");
    $popup.find(".message, .error").html("");
    $popup.find(".message, .error, .btn-confirm").addClass("hide");
    $popup.find(".btn-send-invite, .btn-cancel").removeClass("hide");
  });

  $("#inviteAdmin").on("click", ".btn-send-invite", function () {
    var $popup = $("#inviteAdmin");
    if ($popup.find(".email").val() != "") {
      var $form = $popup.find(".admin-info");
      $popup.find(".loading-div.whirl.no-overlay").removeClass("hide");
      $popup.find(".buttons-row").addClass("hide");
      $popup.find(".message, .error").html("");
      $.ajax({
        type: "POST",
        url: "/admins/send_invitation",
        data: new FormData($form[0]),
        contentType: false,
        cache: false,
        processData: false,
        success: function (result) {
          if (result.status != 300) {
            $popup.find(".message").html(result.message);
            $popup.find(".message, .btn-confirm").removeClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").addClass("hide");
          }
          else {
            $popup.find(".error").html(result.error);
            $popup.find(".error").removeClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").removeClass("hide");
          }
          $popup.find(".buttons-row").removeClass("hide");
          $popup.find(".whirl.no-overlay").addClass("hide");
        }
      });
    }
  });

  if ($(".new-admin").length) {
    $(".aside-container, .topnavbar-wrapper, .offsidebar").remove();
    $(".section-container").addClass("section-admin-register");

    $(document).on('submit', 'form', function () {
      $("button.loading-btn").click();
    });
  }

  if ($(".main-banner").length) {
    // $(".main-banner").on("dragstart", "#drag1", function(){
    //   drag(this);
    // });
    if ($(".main-banner #drag1").length) {
      $(".main-banner #drag1").get(0).addEventListener("dragstart", (event) => {
        event.dataTransfer.setData("text", event.target.id);
      });

      $(".main-banner .main-div").each((div) => {
        this.addEventListener("dragover", (event) => {
          event.preventDefault();
        });
      });

      $(".main-banner .main-div").each((div) => {
        this.addEventListener("drop", (event) => {
          event.preventDefault();
          var data = event.dataTransfer.getData("text");
          event.target.appendChild(document.getElementById(data));
        });
      });
    }

    $(document).on('change', '.upload-files', function () {
      uploadFiles($("form"));
      var filesCount = $(this)[0].files.length;
      var textbox = $(this).prev();
      if (filesCount === 1) {
        var fileName = $(this).val().split('\\').pop();
        textbox.text(fileName);
      } else {
        textbox.text(filesCount + ' files selected');
      }

      if (typeof (FileReader) != "undefined") {
        var dvPreview = $("#divImageMediaPreview");
        dvPreview.find(".temp").remove();
        $($(this)[0].files).each(function () {
          var file = $(this);
          var reader = new FileReader();
          reader.onload = function (e) {
            var ctr = $("<div class='container'/>");
            var img = $("<img />");
            img.attr("src", e.target.result).attr("class", "temp");
            ctr.append(img);
            dvPreview.append(ctr);
          }
          reader.readAsDataURL(file[0]);
        });
      } else {
        alert("This browser does not support HTML5 FileReader.");
      }
    });

    $("#divImageMediaPreview").on("click", ".container .remove-btn", function () {
      removeFile($(this));
    });

    let uploadFiles = function (form) {
      $.ajax({
        type: "POST",
        url: "/admins/banner_upload",
        data: new FormData(form[0]),
        contentType: false,
        cache: false,
        processData: false,
        success: function (result) {
          if (result.status == 200) {
            console.log("result " + result.message)
          }
        }
      });
    }

    let removeFile = function (container) {
      $.ajax({
        type: "POST",
        url: "/admins/banner_remove_image",
        data: { id: container.attr("image_id") },
        success: function (result) {
          if (result.status == 200) {
            container.parents(".container").remove();
          }
          else {
            console.log("error " + result.error)
          }
        }
      });
    }
  }

  if ($(".forgot_password").length) {
    $(".forgot_password").on("click", ".btn-submit", function () {
      if ($(".forgot_password").find(".user-email").val() != "") {
        $('#loadingModal').find(".loading-row").removeClass("hide");
        $('#loadingModal').find(".message-row, .button-row").addClass("hide");
        $('#loadingModal').find(".message, .errir").addClass("hide").html("");
        $("button.loading-btn").click();

        $.ajax({
          type: "PUT",
          url: "/admins/send_reset_token",
          data: { email: $(".forgot_password").find(".user-email").val() },
          success: function (result) {
            $('#loadingModal').find(".loading-row").addClass("hide");
            $('#loadingModal').find(".message-row, .button-row").removeClass("hide");

            if (result.status == 200) {
              $('#loadingModal').find(".message").removeClass("hide").html(result.message);
              $('#loadingModal').find(".btn-confirm").addClass("hide");
              $("#loadingModal").find(".btn-redirect").removeClass("hide");
            }
            else {
              $('#loadingModal').find(".error").removeClass("hide").html(result.message);
            }
          },
          error: function (result) {
          }
        });
      }
    });

    $("#loadingModal").on("click", ".btn-redirect", function () {
      window.location.href = "/sign_in"
    });
  }

  if ($(".admins-reset-password").length) {
    $(".admins-reset-password").on("click", ".btn-submit", function (e) {
      e.preventDefault();
      if ($(".forgot_password").find(".user-email").val() != "") {
        $("button.loading-btn").click();
        var $popup = $('#loadingModal');
        $popup.find(".error, .message").html("");
        var $form = $(".admins-reset-password").find("form");

        $.ajax({
          type: "PUT",
          url: "/admins/set_admin_password",
          data: new FormData($form[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result) {
            console.log("status " + result.status)
            $popup.find(".loading-row").addClass("hide");
            $popup.find(".message-row, .button-row").removeClass("hide");

            if (result.status == 200) {
              $popup.find(".message").removeClass("hide").html(result.message);
              $popup.find(".btn-confirm").addClass("hide");
              $popup.find(".btn-redirect").removeClass("hide");
            }
            else {
              $popup.find(".error").removeClass("hide").html(result.error);
            }
          },
          error: function (result) {
          }
        });
      }
    });

    $("#loadingModal").on("click", ".btn-redirect", function () {
      window.location.href = "/sign_in"
    });
  }
});